import { Component, Input, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ImageService } from '../../../services/image.service';
import { ImageComponent } from '../image/image.component';

@Component({
  selector: 'ig-image-viewer',
  templateUrl: './image.viewer.component.html',
  styleUrls: ['./image.viewer.component.scss']
})
export class ImageViewerComponent implements OnInit {
  @Input() public currentImage = null;
  @Input() public showingCount = 0;
  @Input() public images: any;
  @Input() public alt = 'picture';

  public hasNext = false;
  public hasPrevious = false;
  public currentIndex = 0;

  @ViewChild('imgComp') public imgComp: ImageComponent;

  constructor(private imageService: ImageService, public cdRef: ChangeDetectorRef,) {
  }

  public ngOnInit() {
    // this.isContainImage = !this.imageUrl;
    console.log(`imageviewer, images: ${this.images.length}, showingCount: ${this.showingCount}`);
    this.cdRef.detectChanges();
    if (this.images && this.images.length) {
      this.currentImage = this.images[this.currentIndex];

      if (this.images.length > 1) {
        this.hasNext = true;
      }
    }
  }

  public onNextKeyPress($event) {
    if ($event && $event.key === 'Enter') {
      this.next();
    }
  }

  public next() {
    if (!this.hasNext) return;
    this.currentIndex++;

    this.currentImage = this.images[this.currentIndex];
    this.hasPrevious = true;

    if (this.showingCount !== 0) {
      if (this.currentIndex === this.showingCount - 1) {
        this.hasNext = false;
      }
    } else {
      if (this.currentIndex === this.images.length - 1) {
        this.hasNext = false;
      }
    }
  }

  public onPreviousKeyPress($event) {
    if ($event && $event.key === 'Enter') {
      this.previous();
    }
  }

  public previous() {
    if (!this.hasPrevious) return;

    this.currentIndex--;
    this.currentImage = this.images[this.currentIndex];
    this.hasNext = true;

    if (this.currentIndex === 0) {
      this.hasPrevious = false;
    }
  }

  public updateImage(img) {
    this.imgComp && this.imgComp.updateImage(img);
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.viewer/image.viewer.component.ts